import { NavbarLink, NavbarMenu } from '@/components/ui/navbar-menu'
import { Skeleton } from '@/components/ui/skeleton'
import { Typography } from '@/components/ui/typography'

import * as S from './page-header.styled'
import { PageHeaderProps } from './page-header.types'

export const PageHeader = ({
  title,
  badges,
  titleExtra,
  backButton,
  actions,
  navbarItems,
  loading,
}: PageHeaderProps) => {
  const visibleItems = navbarItems?.filter((item) => !item.hidden) ?? []
  const hasNavbar = visibleItems.length > 0

  return (
    <S.Header>
      <S.Toolbar>
        <S.TitleWrapper>
          {backButton && <S.BackButtonWrapper>{backButton}</S.BackButtonWrapper>}
          {loading ? (
            <Skeleton height="2.8rem" width="16rem" />
          ) : (
            <>
              <Typography as="h1" breakLines={1} color="primary800" size="heading-large">
                {title}
              </Typography>
              {titleExtra}
              <S.BadgesWrapper>{badges}</S.BadgesWrapper>
            </>
          )}
        </S.TitleWrapper>
        {/* Note: If navbar is present, move actions below */}
        {actions && <S.ActionsWrapper>{actions}</S.ActionsWrapper>}
      </S.Toolbar>
      {hasNavbar && (
        <S.NavbarWrapper>
          <NavbarMenu>
            {visibleItems.map((item) => (
              <NavbarLink key={item.to.path} to={item.to}>
                {item.label}
                {item.count ? (
                  <S.NavbarItemCountContainer $isDanger={!!item.isDanger}>
                    {item.count}
                  </S.NavbarItemCountContainer>
                ) : null}
              </NavbarLink>
            ))}
          </NavbarMenu>
        </S.NavbarWrapper>
      )}
    </S.Header>
  )
}
